module.exports = __webpack_public_path__ + "static/media/预约-潜在.7eb5b50f.svg";